export default {
	locale: "en-US", // probaly array of all possible locales, first one would be default

	// Logo file name in ../assets/img/
	// If null show placeholder
	logo: "abc_logo.png",

	// Some design changes per tenant
	theme: {
		logoBackgroundColor: null //any valid css value for colors
	},

	// Insurance types
	// Enums we can use here are defined in localization.insurance_types
	// TODO: enable camelCase products after Kobe fixes conversion from ENUM to String
	typesOfInsurance: [
		"travel",
		"motor",
		"home",
		"life",
		// "criticalIllness",
		"medical",
		// "personalAccident",
		// "domesticHelper",
		"endowment",
		// "investmentLinked",
		"mpf",
		"retirement",
		"vhis",
		"public_liability"
	],

	// TODO: this should be removed
	// We should get password rules from API because
	// when user is not logged in he can't see settings
	passwordRules: {
		requireLength: 8,
		requireDigit: true,
		requireLowercase: true,
		requireNonAlphanumeric: true,
		requireUppercase: true,
		requireUniqueChars: 1
	},

	// we use dayjs syntax: https://github.com/iamkun/dayjs/blob/master/docs/en/API-reference.md#format-formatstringwithtokens-string
	dateFormat: "DD/MM/YYYY",
	dateTimeFormat: "DD/MM/YYYY HH:mm:ss",

	// ENUM of preferred currency
	// ENUMs of currencies are defined in localization
	preferredCurrency: "HKD",

	// Flags for development in case we need some flags to show/hide some features for development
	devFlags: {
		hasDemoNote: true,
		hasCommissions: true,
		hasFakeSettings: true,
		hasAdvancedUserManagement: true,
		hasDeleteProducts: true
	},

	// Settings for files upload
	filesUpload: {
		types: [
			"jpg",
			"jpeg",
			"png",
			"gif",
			"tiff",
			"webp",
			"pdf",
			"doc",
			"xdoc",
			"csv",
			"xls",
			"xlsx",
			"zip",
			"rar"
		],
		maxFileSize: 15 * 1024 * 1024
	},

	// What features can be seen by this client
	// Affects top menu and router global guard
	// id is used in router to prevent showing features that are not allowed
	// name and slug are used for menu in UI
	features: [
		"dashboard",
		"clients",
		"fileSystem",
		"policies",
		"products",
		"caseManagement",
		"claims",
		"reports",
		"users",
		"internals",
		"organizations",
		"binders",
		"setup"
	],

	// Feature Dashboard
	dashboard: {
		detail: {
			hasNumberOfClients: true,
			hasNumberOfPolicies: true,
			hasNumberOfQuotes: true,
			hasGraph: false
		}
	},

	// Feature clients
	clients: {
		creating: {
			// TODO: probably form config here
		},
		listing: {
			itemsPerPage: 30,
			// Here is a list of fields that will be mapped to GraphQL output
			columns: {
				individual: ["name", "email", "dateOfBirth", "createdAt", "actions"],
				company: [
					"name",
					"registrationNumber",
					"email",
					"natureOfBusiness",
					"createdAt",
					"actions"
				]
			}
		},
		detail: {
			submenu: {
				individual: [
					"overview",
					"policies",
					"objects",
					"logs" /*"quotes", "relationships"*/
				],
				company: [
					"overview",
					"policies",
					"objects",
					"logs" /*"quotes", "relationships", "employees"*/
				]
			}
		},
		updating: {}
	},

	// Feature Quotes
	quotes: {
		actions: {
			hasActions: true,
			hasRequestPayment: false,
			hasIssuePolicy: true
		},

		offers: {
			hasSendOffer: false
		},

		detail: {
			hasReject: true,
			hasChangeHolder: true,
			hasAddOtherHolder: true,
			hasRemoveOtherHolder: true,
			hasAddInsured: true,
			hasRemoveInsured: true
		}
	},

	// Feature policies
	policies: {
		creating: {
			hasApiCreation: false,
			hasManualCreation: false
		},
		actions: {
			hasActions: false,
			hasRequestPayment: false,
			hasSendConfirmation: false
		},
		cancelling: {
			hasCancel: true,
			hasSendEmail: false
		}
	},

	// Feature Products
	products: {
		hasBenefitsEditor: true,
		hasUnderwritingEditor: true,
		hasPricingEditor: true
	},

	// Feature Reports
	reports: {
		reporting: {
			hasDefault: true,
			hasVHIS: false
		}
	}
}
